import React from 'react';
import { TextField, InputAdornment, FormControl } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

interface DealListSearchProps {
  value: string;
  onChange: (val: string) => void;
  clearFn: () => void;
  placeholder: string;
}

const DealListSearch = ({
  value,
  onChange,
  clearFn,
  placeholder
}: DealListSearchProps) => {
  return (
    <FormControl fullWidth size="small">
      <TextField
        fullWidth
        placeholder={placeholder}
        value={value}
        size="small"
        onChange={(e) => {
          onChange(e.target.value);
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              sx={{
                display: {
                  xs: 'none',
                  sm: 'flex'
                }
              }}
            >
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <ClearIcon style={{ cursor: 'pointer' }} onClick={clearFn} />
            </InputAdornment>
          )
        }}
      />
    </FormControl>
  );
};

export default DealListSearch;
